import { Link } from 'react-router-dom';

const footerLinks = {
  categories: [
    { label: '首存送彩金', path: '/category/first-deposit' },
    { label: '签到送彩金', path: '/category/sign-in' },
    { label: '邀请好友送彩金', path: '/category/invite' },
    { label: '天天送彩金', path: '/category/daily' },
    { label: 'VIP专属彩金', path: '/category/vip' },
    { label: '节日送彩金', path: '/category/festival' },
  ],
  articles: [
    { label: '2026送彩金平台大盘点', path: '/article/1' },
    { label: '首存送彩金全攻略', path: '/article/2' },
    { label: '签到送彩金实测对比', path: '/article/3' },
    { label: '邀请好友终极玩法', path: '/article/4' },
  ],
  about: [
    { label: '关于我们', path: '/about' },
    { label: '品牌介绍', path: '/about#brand' },
    { label: '信誉展示', path: '/about#reputation' },
    { label: '联系我们', path: '/about#contact' },
  ],
};

export default function Footer() {
  return (
    <footer className="bg-secondary-900 text-background-50">
      <div className="max-w-[1400px] mx-auto px-4 md:px-6 py-14">
        <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-4 gap-8">
          <div>
            <Link to="/" className="text-2xl font-heading font-bold text-background-50 whitespace-nowrap">
              送彩金
            </Link>
            <p className="mt-3 text-sm text-background-300 leading-relaxed">
              送彩金活动火热进行中！注册即可领取专属彩金，多种送彩金方式任你选择。彩金到账快速，提款无忧！
            </p>
          </div>

          <div>
            <h4 className="text-sm font-semibold text-background-50 mb-4">彩金分类</h4>
            <ul className="space-y-2">
              {footerLinks.categories.map((link) => (
                <li key={link.path}>
                  <Link to={link.path} className="text-sm text-background-300 hover:text-accent-400 transition-colors whitespace-nowrap">
                    {link.label}
                  </Link>
                </li>
              ))}
            </ul>
          </div>

          <div>
            <h4 className="text-sm font-semibold text-background-50 mb-4">精选文章</h4>
            <ul className="space-y-2">
              {footerLinks.articles.map((link) => (
                <li key={link.path}>
                  <Link to={link.path} className="text-sm text-background-300 hover:text-accent-400 transition-colors whitespace-nowrap">
                    {link.label}
                  </Link>
                </li>
              ))}
            </ul>
          </div>

          <div>
            <h4 className="text-sm font-semibold text-background-50 mb-4">关于</h4>
            <ul className="space-y-2">
              {footerLinks.about.map((link) => (
                <li key={link.path}>
                  <Link to={link.path} className="text-sm text-background-300 hover:text-accent-400 transition-colors whitespace-nowrap">
                    {link.label}
                  </Link>
                </li>
              ))}
            </ul>
          </div>
        </div>

        <div className="mt-10 pt-6 border-t border-background-700/30 flex flex-col sm:flex-row items-center justify-between gap-3">
          <p className="text-xs text-background-500">
            &copy; {new Date().getFullYear()} 送彩金 All Rights Reserved.
          </p>
          <p className="text-xs text-background-500">
            本网站仅供信息参考，请理性参与彩金活动
          </p>
        </div>
      </div>
    </footer>
  );
}